import React from "react";

const LearningIcon = ({ className = "", size = 40 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Brain outline */}
      <path
        d="M32 8C26 8 20 12 20 24C20 28 16 30 12 30C8 30 8 34 12 38C16 42 12 46 16 50C20 54 28 56 32 56C36 56 44 54 48 50C52 46 48 42 52 38C56 34 56 30 52 30C48 30 44 28 44 24C44 12 38 8 32 8Z"
        stroke="#00FF8F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Neural connections */}
      <path
        d="M24 24C24 24 28 28 32 28C36 28 40 24 40 24"
        stroke="#00FF8F"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M20 36C20 36 28 40 32 40C36 40 44 36 44 36"
        stroke="#00FF8F"
        strokeWidth="2"
        strokeLinecap="round"
      />

      {/* Brain nodes */}
      <circle cx="28" cy="20" r="3" fill="#00FF8F" fillOpacity="0.5" />
      <circle cx="36" cy="20" r="3" fill="#00FF8F" fillOpacity="0.7" />
      <circle cx="24" cy="36" r="3" fill="#00FF8F" fillOpacity="0.3" />
      <circle cx="32" cy="36" r="3" fill="#00FF8F" fillOpacity="0.5" />
      <circle cx="40" cy="36" r="3" fill="#00FF8F" fillOpacity="0.7" />
      <circle cx="32" cy="48" r="3" fill="#00FF8F" fillOpacity="0.6" />

      {/* Light rays / knowledge */}
      <path
        d="M32 2V8"
        stroke="#00FF8F"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M40 4L38 9"
        stroke="#00FF8F"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M24 4L26 9"
        stroke="#00FF8F"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default LearningIcon;
